import { Link, useLocation } from "@tanstack/react-router";
import { Home, Smartphone, Monitor, Wallet, User, FileText, LogIn } from "lucide-react";
import { useAppStore } from "@/lib/store";

const navItems: Array<{
  to: string;
  icon: typeof Home;
  label: string;
  requiresAuth?: boolean;
}> = [
  { to: "/", icon: Home, label: "Home" },
  { to: "/app-tests", icon: Smartphone, label: "App Tests" },
  { to: "/webapp-tests", icon: Monitor, label: "Web Tests" },
  { to: "/wallet", icon: Wallet, label: "Wallet", requiresAuth: true },
  { to: "/profile", icon: User, label: "Profile", requiresAuth: true },
  { to: "/my-bids", icon: FileText, label: "My Tests", requiresAuth: true },
];

export function BottomNav() {
  const location = useLocation();
  const isGuest = useAppStore((s) => s.isGuest);
  const isAuthenticated = useAppStore((s) => s.isAuthenticated);

  const isActive = (href: string) => {
    if (href === "/") return location.pathname === "/";
    return location.pathname.startsWith(href);
  };

  const visibleItems = isGuest
    ? navItems.filter((item) => !item.requiresAuth)
    : isAuthenticated
      ? navItems
      : navItems.filter((item) => !item.requiresAuth);

  return (
    <nav
      data-bottom-nav="true"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-blue-200 bg-white/95 backdrop-blur-md shadow-[0_-4px_20px_rgba(0,0,0,0.08)] transition-all duration-200 pb-[env(safe-area-inset-bottom)] md:hidden"
    >
      <div className="flex items-center justify-around py-2 overflow-x-auto">
        {visibleItems.map((item) => {
          const active = isActive(item.to);

          if (active) {
            return (
              <Link
                key={item.to}
                to={item.to}
                className="flex flex-col items-center gap-0.5 px-3 py-2 rounded-xl text-white bg-linear-to-br from-blue-600 to-indigo-600 shadow-lg shadow-blue-500/25 min-h-[48px] justify-center"
              >
                <item.icon className="h-5 w-5" />
                <span className="text-[10px] font-bold">{item.label}</span>
              </Link>
            );
          }

          return (
            <Link
              key={item.to}
              to={item.to}
              className="flex flex-col items-center gap-0.5 px-3 py-2 text-slate-500 hover:text-blue-600 transition-colors min-h-[48px] justify-center"
            >
              <item.icon className="h-5 w-5" />
              <span className="text-[10px] font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
